module.exports = __webpack_public_path__ + "static/img/qianqingyichang1@2x.a99721d2.png";